import React, { useState, useEffect, useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Header from './Header';
import endpoints from '../constants/endpoints';
import ProjectCard from './projects/ProjectCard';
import FallbackSpinner from './FallbackSpinner';
import AppContext from '../AppContext';
import { getTranslation } from '../constants/translations';
import '../css/projectcard.css'; // Ensure this contains the animation styles

const Projects = ({ header }) => {
  const { language } = useContext(AppContext);
  const t = getTranslation(language).projects;
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(endpoints.projects)
      .then((res) => {
        console.log('Response status:', res.status);
        if (!res.ok) throw new Error(`Error: ${res.statusText}`);
        return res.json();
      })
      .then((data) => {
        console.log('Fetched projects:', data);
        setData(data.projects);
        setIsLoading(false);
      })
      .catch((err) => console.error('Error fetching projects:', err));
  }, []);

  return (
    <>
      {isLoading ? (
        <FallbackSpinner />
      ) : (
        <div className="fade-in">
          <div className="header-container">
            <Header title={header} />
          </div>

          <div className="section-content-container">
            <Container fluid>
              {data && data.length > 0 ? (
                <>
                  <Row xs={1} sm={1} md={2} lg={3} className="g-4">
                    {data.map((project, index) => (
                      <div key={index} className="fade-in">
                        <ProjectCard project={project} />
                      </div>
                    ))}
                  </Row>
                </>
              ) : (
                <p>{t.noProjects}</p>
              )}
            </Container>
          </div>
        </div>
      )}
    </>
  );
};

Projects.propTypes = {
  header: PropTypes.string.isRequired,
};

export default Projects;
